import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import useForm from "react-hook-form";
import clsx from "clsx";
import { Modal } from "antd";
import { makeStyles } from "@material-ui/styles";
import { notification } from "antd";
import ilustradozApi from "../../api/ilustradozApi";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  paginate: {
    marginTop: theme.spacing(3),
    display: "flex",
    justifyContent: "center",
  },
}));
const AddBlock = (props) => {
  const classes = useStyles();
  const [subjects, setsubjects] = useState([]);
  const { register, errors, handleSubmit } = useForm({});

  useEffect(() => {
    getSubjects();
  }, []);

  const getSubjects = async () => {
    let res = await ilustradozApi.get("/academic/subjects");
    if (res.status === 200) {
      setsubjects(res.data);
    }
  };

  const onSubmit = async (event, e) => {
    let obj = {
      name: event.name,
      subject: event.subject,
      block: event.block,
    };
    let res = await ilustradozApi.post(`/lessons/create`, obj);
    if (res.status === 200) {
      notification.open({
        message: "Crear Lección",
        description: "El Reto  fue creado satisfactoriamente.",
        // icon: <Icon type="check" style={{ color: "#49E02D" }} />,
        key: `open${Date.now()}`,
      });
      e.target.reset();
      props.setVisible(false);
      props.setupdate({ ...true });
    } else {
      notification.open({
        message: "Crear Lección",
        description: "Ocurrio un error al grabar el Reto.",
        // icon: <Icon type="close" style={{ color: "#FE2E27" }} />,
        key: `open${Date.now()}`,
      });
    }
  };

  return (
    <Modal
      visible={props.visible}
      footer={null}
      onCancel={() => props.setVisible(false)}
    >
      <>
        <h3>Añadir Lección</h3>
        <form
          autoComplete="off"
          className={clsx(classes.root)}
          onSubmit={handleSubmit(onSubmit)}
        >
          <label for="exampleInputEmail1">Nombre * </label>
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="name"
              placeholder="Ingresar Nombre del Reto"
              ref={register({
                required: "Nombre Requerido",
              })}
            />
          </div>
          <p className="text-danger">{errors.name && errors.name.message}</p>
          <label for="exampleInputEmail1">Curso *</label>
          <div class="input-group mb-3">
            <select
              name="subject"
              className="form-control"
              ref={register({
                required: "Curso Requerido",
              })}
            >
              {subjects.map((e) => (
                <option value={e._id}>{`${e.name} - ${e.university}`}</option>
              ))}{" "}
            </select>
          </div>
          <p className="text-danger">
            {errors.subject && errors.subject.message}
          </p>
          <label for="exampleInputEmail1">Bloque *</label>
          <div class="input-group mb-3">
            <select
              name="block"
              className="form-control"
              placeholder="Subcategoría"
              ref={register({})}
            >
              <option value={1}>1</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
            </select>

            <p className="text-danger">
              {errors.block && errors.block.message}
            </p>
          </div>
          <p>(*) Campos obligatorios</p>
          <Button
            className={classes.submitButton}
            color="secondary"
            size="large"
            type="submit"
            variant="contained"
          >
            Añadir
          </Button>
        </form>
      </>
    </Modal>
  );
};

export default AddBlock;
